import { useQuery } from "react-query";
import { SERVICE_API_URL } from "../utils/constants";
import { requestWithToken } from "../utils/functions";

import qs from "qs";

export function resolveInstances(service_uuid: string) {
  return useQuery(["customer.services.instances", service_uuid], async () => {
    const response = await requestWithToken(`${SERVICE_API_URL}/v2/services/${service_uuid}/instances`)

    const instances = response?.data?.data?.instances || []
    const healthz = response?.data?.data?.healthz

    return {
      instances,
      healthz
    }
  }, {
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    retry: false,
    staleTime: 5 * 60 * 1000,
    enabled: typeof service_uuid !== "undefined",
    suspense: true
  })
}

export function resolveInstanceDetail(service_uuid: string, instance_id?: string) {
  return useQuery(["customer.services.instances.detail", service_uuid, instance_id], async () => {
    const response = await requestWithToken(`${SERVICE_API_URL}/v2/services/${service_uuid}/instances/${instance_id}`)

    return response?.data?.data?.instance
  }, {
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    retry: false,
    staleTime: 5 * 60 * 1000,
    enabled: typeof service_uuid !== "undefined" && typeof instance_id !== "undefined",
    suspense: true
  })
}

export function resolveInstanceMetadata(service_uuid: string, instance_id?: string) {
  return useQuery(["customer.services.instances.info", service_uuid, instance_id], async () => {
    const response = await requestWithToken(`${SERVICE_API_URL}/v2/services/${service_uuid}/instances/${instance_id}/info`)

    return response?.data?.data?.info
  }, {
    keepPreviousData: true,
    retry: false,
    enabled: typeof service_uuid !== "undefined" && typeof instance_id !== "undefined",
    suspense: true,
    refetchInterval: 30 * 1000
  })
}

export function resolveInstanceSummary(service_uuid: string, instance_id?: string) {
  return useQuery(["customer.services.instances.summary", service_uuid, instance_id], async () => {
    try {
      const response = await requestWithToken(`${SERVICE_API_URL}/v2/services/${service_uuid}/instances/${instance_id}/summary`)

      return response?.data?.data?.summary
    } catch (e) {
      return null
    }
  }, {
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    retry: false,
    staleTime: 60 * 1000,
    enabled: typeof service_uuid !== "undefined" && typeof instance_id !== "undefined",
    suspense: true
  })
}

export function resolveInstanceMonitoring(service_uuid: string, instance_id: string, query: any) {
  query = qs.stringify(query);

  return useQuery(["customer.services.instances.stats", service_uuid, instance_id, query], async () => {
    try {
      const response = await requestWithToken(`${SERVICE_API_URL}/v2/services/${service_uuid}/instances/${instance_id}/stats?${query}`)

      return response?.data?.data?.summary
    } catch (e) {
      return null
    }
  }, {
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    retry: false,
    staleTime: 60 * 1000,
    enabled: typeof service_uuid !== "undefined" && typeof instance_id !== "undefined",
    suspense: true,
    refetchInterval: 60 * 1000
  })
}

export async function submitInstancePerform(service_uuid: string, instance_id?: string, perform?: string, context?: any) {
  const response = await requestWithToken(`${SERVICE_API_URL}/v2/services/${service_uuid}/instances/${instance_id}/perform`, 'POST', { perform, context })

  return response?.data;
}

export function resolveInstanceRemoteTicket(service_uuid: string, instance_id?: string) {
  return useQuery(["customer.services.instances.remote", service_uuid, instance_id], async () => {
    try {
      const response = await requestWithToken(`${SERVICE_API_URL}/v2/services/${service_uuid}/instances/${instance_id}/acquire_ticket`)

      return response?.data?.data
    } catch (e) {
      return null
    }
  }, {
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    retry: false,
    staleTime: 60 * 1000,
    enabled: typeof service_uuid !== "undefined" && typeof instance_id !== "undefined",
    suspense: true
  })
}